module.exports = __webpack_public_path__ + "static/img/help_pdf.3078001.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/help_pdf.png
// module id = 885
// module chunks = 1